import React, { FC } from 'react';

import block from 'propmods';

import './Progress.scss';

const b = block('Progress');

interface Props {
    value: number;
    max?: number;
    text?: string;
    format?: (value: number) => void;
}

const Progress: FC<Props> = ({ value, max = 100, format = (v: number) => v }) => {
    const width = (value / max) * 100;
    return (
        <div {...b()}>
            <div {...b('inner')} style={{ width: `${width}%` }} />
            <div {...b('text')}>
                {format(value)} / {format(max)}
            </div>
        </div>
    );
};

export default Progress;
